module.exports = __webpack_public_path__ + "static/media/exit.4ba707f0.svg";